import React, { useEffect, useRef } from "react";

import GeneralAccordionSetWrapper from "../shared/accordions/generalAccordionSetWrapper";

const GroupProgramAccordion = ({
  accordions,
  getActiveTabSlidebySlug,
  setActiveTabSlidebySlug,
  ...props
}) => {
  // getActiveTabSlidebySlug
  const accordionsRef = useRef(null);

  useEffect(() => {
    let url = new URL(window?.location?.href);
    const currentAccordionTitle = url.searchParams.get("tab");

    if (!currentAccordionTitle) {
      setActiveTabSlidebySlug(0);
    } else {
      const currentAccordion = document.querySelector(
        `#${currentAccordionTitle}`
      );

      currentAccordion.scrollIntoView({ behavior: "auto", block: "start" });

      setActiveTabSlidebySlug(currentAccordionTitle);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleAccordionClick = (accordionTag, singleAccordionRef) => {
    if (accordionTag !== getActiveTabSlidebySlug) {
      setActiveTabSlidebySlug(accordionTag);

      const url = new URL(window.location);
      url.searchParams.set("tab", accordionTag);
      window.history.pushState({}, "", url);

      accordionsRef.current.scrollTo(0, 0);
      setTimeout(() => {
        document.querySelector(`#${accordionTag}`).scrollIntoView();
      }, 100);
    } else {
      //reset
      setActiveTabSlidebySlug(0);
    }
  };

  return (
    <>
      <section
        className="flex items-center justify-center w-[calc(100vw-12px)] pt-10 pb-5 md:py-20 mx-auto bg-white md:w-full md:px-0 dark:gvi-dark-gray-bg"
        id={"view-accordions"}
      >
        <div className="container relative flex flex-col w-full mb-6">
          <div className="divide-y height-divider mb-10 border-[0.5px] border-gray-standard" />

          <div
            className="relative justify-between w-full sm:flex"
            ref={accordionsRef}
          >
            <div
              className="text-lrg lato-300-latin pb-5 not-italic font-light dark:!text-gray-generic"
              dangerouslySetInnerHTML={{ __html: "Essential program info" }}
            />
            <GeneralAccordionSetWrapper
              list={accordions}
              currentSlide={getActiveTabSlidebySlug}
              setCurrentSlide={handleAccordionClick}
              accordionIdentifier="accordionSlug"
            />
          </div>
        </div>
      </section>
    </>
  );
};

export default GroupProgramAccordion;
